<div class="d-flex justify-content-end align-items-center w-100 mb-2 gap-3">
    <!-- Optional tenant/company selector projected in by a hosting screen (e.g. uiconfig's
         Global Policy page) so it sits in the same row as Branch/Category/Add — this
         component has no tenant selector of its own since it's normally handed a fixed
         companyId by its host (e.g. company-detail). -->
    <ng-content select="[tenantSelector]"></ng-content>

    <!-- Branch Dropdown -->
    <div>
        <select id="branchSelect" class="form-select form-select-sm" [(ngModel)]="selectedBranchId"
            (change)="onBranchChange($event)" [disabled]="isDataLoading">
            <option [value]="0" disabled *ngIf="!allowDefaultBranch">Select Branch</option>
            <option *ngFor="let branch of branchList" [value]="branch.key">
                {{ branch.value }}
            </option>
        </select>
    </div>

    <div>
        <select id="ruleCategoryFilter" class="form-select form-select-sm" [(ngModel)]="selectedRuleCategory"
            (change)="onRuleCategoryFilterChange()" [disabled]="isDataLoading || (selectedBranchId === 0 && !allowDefaultBranch)">
            <option value="">All Categories</option>
            <option *ngFor="let cat of availableCategories" [value]="cat">
                {{ cat }}
            </option>
        </select>
    </div>


    <!-- Add Button -->
    <div>
        <button class="btn btn-sm btn-primary shadow-sm" (click)="addGlobalPolicyRule()"
            [disabled]="isDataLoading || (selectedBranchId === 0 && !allowDefaultBranch)">
            <i class="bi bi-plus-circle me-1"></i> {{buttonHeader}}
        </button>
    </div>
</div>
<!-- GLOBAL POLICY RULES TABLE -->
<div class="table-responsive table-container" (scroll)="onScroll($event)">
    <table class="table table-sm table-hover table-bordered align-middle">
        <thead class="table-light" [class.scrolled]="isScrolled">
            <tr>
                <th style="width: 4%;">Actions</th>
                <th style="width: 4%;">Sr No.</th>
                <th style="width: 12%;">Category</th>
                <th style="width: 13%;">Rule Name</th>
                <th style="width: 17%;">Description</th>
                <th style="width: 14%;">Field Key / Type</th>
                <th style="width: 17%;">Rule Script</th>
            </tr>
        </thead>

        <tbody>
            <ng-container *ngIf="!isDataLoading && globalPolicyRulesData.length > 0; else noDataTemplate">
                <tr *ngFor="let rule of globalPolicyRulesData; let i = index" class="text-dark">
                    <td class="text-center" style="overflow: visible; max-width: 30px;">
                        <div class="btn-group dots_dropdown" ngbDropdown container="body" placement="bottom-end">
                            <button type="button" class="dropdown-toggle" ngbDropdownToggle>
                                <i class="bi bi-three-dots-vertical"></i>
                            </button>
                            <div class="dropdown-menu shadow-lg" ngbDropdownMenu>
                                <button class="dropdown-item" type="button" (click)="editGlobalPolicyRule(rule)">
                                    <i class="fa fa-edit"></i> Edit
                                </button>
                                <button class="dropdown-item" type="button" (click)="deleteGlobalPolicyRule(rule)">
                                    <i class="fa fa-trash"></i> Delete
                                </button>
                            </div>
                        </div>
                    </td>
                    <td>{{ i + 1 }}</td>
                    <td>{{ rule.ruleCategory }}</td>
                    <td>{{ rule.ruleName }}</td>
                    <td class="text-truncate" [title]="rule.ruleDescription">{{ rule.ruleDescription }}</td>
                    <td class="text-truncate small" [title]="getParamFieldDisplay(rule)">{{ getParamFieldDisplay(rule) }}</td>
                    <td class="text-truncate small font-monospace" [title]="rule.ruleScript">{{ rule.ruleScript || '—'
                        }}</td>
                    

                </tr>
            </ng-container>

            <ng-template #noDataTemplate>
                <tr>
                    <td colspan="8" class="text-center">
                        <span *ngIf="isDataLoading" class="text-primary">
                            <span class="spinner-border spinner-border-sm me-2"></span>
                            Loading...
                        </span>
                        <span *ngIf="!isDataLoading && selectedBranchId === 0 && !allowDefaultBranch" class="text-muted">
                            Please select a branch to view global policy rules
                        </span>
                        <span *ngIf="!isDataLoading && (selectedBranchId !== 0 || allowDefaultBranch)" class="text-danger">
                            No Records Found
                        </span>
                    </td>
                </tr>
            </ng-template>
        </tbody>
    </table>
</div>


<!-- MODAL TEMPLATE FOR GLOBAL POLICY RULE FORM -->
<ng-template #GlobalPolicyRuleForm>
    <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Update' : 'Create' }} Global Policy Rule</h5>
        <div class="d-flex align-items-center gap-2">
            <button type="button" class="btn btn-sm btn-outline-light text-nowrap" (click)="openHowToGuide()">
                <i class="bi bi-question-circle me-1"></i>How to configure rule
            </button>
            <button type="button" class="btn-close" (click)="ruleModalRef.close()"></button>
        </div>
    </div>

    <div class="modal-body">
        <form [formGroup]="ruleForm">
            <div class="row g-3">
                <!-- Rule Category -->
                <div class="col-md-4">
                    <label for="ruleCategory">Rule Category <span class="text-danger">*</span>
                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                            ngbTooltip="Groups this rule under a category (e.g. Attendance, Leave). Categories become the tabs shown when a tenant builds a policy out of these rules."
                            triggers="hover click" container="body"></i>
                    </label>
                    <select id="ruleCategory" class="form-select form-select-sm" [ngModel]="selectedCategoryOption"
                        [ngModelOptions]="{standalone: true}" (ngModelChange)="onCategorySelectChange($event)"
                        [class.is-invalid]="ruleForm.get('ruleCategory')?.invalid && ruleForm.get('ruleCategory')?.touched">
                        <option value="" disabled>Select category</option>
                        <option *ngFor="let cat of ruleCategories" [value]="cat">{{ cat }}</option>
                        <option value="__custom__">Other </option>
                    </select>
                    <input *ngIf="isCustomCategory" type="text" formControlName="ruleCategory"
                        class="form-control form-control-sm mt-2" placeholder="Enter custom category"
                        [class.is-invalid]="ruleForm.get('ruleCategory')?.invalid && ruleForm.get('ruleCategory')?.touched">
                    <div class="text-danger small"
                        *ngIf="ruleForm.get('ruleCategory')?.invalid && ruleForm.get('ruleCategory')?.touched">
                        Rule Category is required
                    </div>
                </div>

                <!-- Rule Name -->
                <div class="col-md-8">
                    <label for="ruleName">Rule Name <span class="text-danger">*</span>
                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                            ngbTooltip="Shown as this field's label wherever the rule is applied to a policy."
                            triggers="hover click" container="body"></i>
                    </label>
                    <input type="text" id="ruleName" formControlName="ruleName" class="form-control form-control-sm"
                        placeholder="e.g. Standard Grace Period"
                        [class.is-invalid]="ruleForm.get('ruleName')?.invalid && ruleForm.get('ruleName')?.touched">
                    <div class="invalid-feedback"
                        *ngIf="ruleForm.get('ruleName')?.invalid && ruleForm.get('ruleName')?.touched">
                        Rule Name is required
                    </div>
                </div>

                <!-- Rule Description -->
                <div class="col-md-12">
                    <label for="ruleDescription">Description
                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                            ngbTooltip="Optional plain-language explanation. Rendered as the info-icon tooltip next to this field when the rule is applied."
                            triggers="hover click" container="body"></i>
                    </label>
                    <input type="text" id="ruleDescription" formControlName="ruleDescription"
                        class="form-control form-control-sm" placeholder="What this rule does">
                </div>

                <!-- Rule Script -->
                <div class="col-md-12">
                    <label for="ruleScript">Rule Script <span class="text-muted small">(optional)</span>
                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                            ngbTooltip="Custom conditional formula for advanced rules only. Most rules don't need this — leave it blank and use the Param Definition builder below instead."
                            triggers="hover click" container="body"></i>
                    </label>
                    <textarea id="ruleScript" formControlName="ruleScript" rows="2"
                        class="form-control form-control-sm font-monospace"
                        placeholder="e.g. IF CheckInTime &gt; ShiftStart + GraceMinutes THEN Status = 'LateMark'"></textarea>
                </div>

                <!-- Param Definition Builder -->
                <div class="col-md-12">
                    <label class="d-block mb-1">Param Definition</label>
                    <div class="border rounded p-3">

                        <div class="row g-2">
                            <div class="col-md-4">
                                <label for="paramFieldType" class="small text-muted">What kind of control is this?
                                    <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                        ngbTooltip="A Yes/No switch, a dropdown (pick one), a multi-select (pick many), a plain number, a time (HH:MM), or a repeatable table of rows."
                                        triggers="hover click" container="body"></i>
                                </label>
                                <select id="paramFieldType" class="form-select form-select-sm"
                                    [(ngModel)]="paramFieldType" [ngModelOptions]="{standalone: true}">
                                    <option *ngFor="let ft of fieldTypeOptions" [value]="ft.value">{{ ft.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label for="paramFieldKey" class="small text-muted">Field Key <span
                                        class="text-muted">(auto-filled)</span>
                                    <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                        ngbTooltip="Technical key used to store this field's value — auto-filled from the Rule Name above, but you can change it. Use camelCase, no spaces (e.g. lateMarkBasis)."
                                        triggers="hover click" container="body"></i>
                                </label>
                                <input type="text" id="paramFieldKey" class="form-control form-control-sm"
                                    [(ngModel)]="paramFieldKey" [ngModelOptions]="{standalone: true}"
                                    placeholder="Filled in automatically from Rule Name">
                            </div>
                            <div class="col-md-4">
                                <label for="paramControlLabel" class="small text-muted">Control Label <span
                                        class="text-muted">(optional)</span>
                                    <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                        ngbTooltip="A short caption shown right next to the control itself, in addition to the Rule Name — useful when the control needs its own micro-label (e.g. 'Deduction as Salary of Day')."
                                        triggers="hover click" container="body"></i>
                                </label>
                                <input type="text" id="paramControlLabel" class="form-control form-control-sm"
                                    [(ngModel)]="paramControlLabel" [ngModelOptions]="{standalone: true}"
                                    placeholder="e.g. Deduction as Salary of Day">
                            </div>

                            <ng-container [ngSwitch]="paramFieldType">

                                <!-- select -->
                                <div class="col-12" *ngSwitchCase="'select'">
                                    <label class="small text-muted">Dropdown Options
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="The choices offered in this dropdown. Add each one, then pick which becomes the default below."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <div class="d-flex gap-2 mb-2">
                                        <input type="text" class="form-control form-control-sm"
                                            [(ngModel)]="newParamOption" [ngModelOptions]="{standalone: true}"
                                            placeholder="Add an option"
                                            (keydown.enter)="$event.preventDefault(); addParamOption()">
                                        <button type="button" class="btn btn-sm btn-outline-secondary text-nowrap"
                                            (click)="addParamOption()">Add</button>
                                    </div>
                                    <div class="d-flex flex-wrap gap-1 mb-2">
                                        <span class="badge bg-light text-dark border" *ngFor="let opt of paramOptions">
                                            {{ opt }}
                                            <i class="fa fa-times ms-1" style="cursor:pointer"
                                                (click)="removeParamOption(opt)"></i>
                                        </span>
                                        <span class="small text-muted" *ngIf="paramOptions.length === 0">No options
                                            added yet</span>
                                    </div>
                                    <label class="small text-muted">Default Value
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="Pre-selected automatically when this rule is added to a policy, before anyone changes it."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <select class="form-select form-select-sm" style="max-width:280px"
                                        [(ngModel)]="paramDefaultValue" [ngModelOptions]="{standalone: true}">
                                        <option *ngFor="let opt of paramOptions" [value]="opt">{{ opt }}</option>
                                    </select>
                                </div>

                                <!-- multiselect -->
                                <div class="col-12" *ngSwitchCase="'multiselect'">
                                    <label class="small text-muted">Options
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="The full list of choices available. Any number of them can be selected at once when this rule is applied."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <div class="d-flex gap-2 mb-2">
                                        <input type="text" class="form-control form-control-sm"
                                            [(ngModel)]="newParamOption" [ngModelOptions]="{standalone: true}"
                                            placeholder="Add an option"
                                            (keydown.enter)="$event.preventDefault(); addParamOption()">
                                        <button type="button" class="btn btn-sm btn-outline-secondary text-nowrap"
                                            (click)="addParamOption()">Add</button>
                                    </div>
                                    <div class="d-flex flex-wrap gap-1 mb-2">
                                        <span class="badge bg-light text-dark border" *ngFor="let opt of paramOptions">
                                            {{ opt }}
                                            <i class="fa fa-times ms-1" style="cursor:pointer"
                                                (click)="removeParamOption(opt)"></i>
                                        </span>
                                        <span class="small text-muted" *ngIf="paramOptions.length === 0">No options
                                            added yet</span>
                                    </div>
                                    <label class="small text-muted d-block">Default Selected
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="Which options are checked by default when this rule is added to a policy."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <div class="d-flex flex-wrap gap-3">
                                        <div class="form-check" *ngFor="let opt of paramOptions">
                                            <input class="form-check-input" type="checkbox" [id]="'msdef_' + opt"
                                                [checked]="paramDefaultMultiselect.includes(opt)"
                                                (change)="toggleMultiselectDefault(opt)">
                                            <label class="form-check-label small" [for]="'msdef_' + opt">{{ opt
                                                }}</label>
                                        </div>
                                    </div>
                                </div>

                                <!-- boolean -->
                                <div class="col-12" *ngSwitchCase="'boolean'">
                                    <label class="small text-muted d-block">Default Value
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="Whether this toggle starts On or Off when the rule is first added to a policy."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="paramDefaultBool"
                                            [(ngModel)]="paramDefaultBool" [ngModelOptions]="{standalone: true}">
                                        <label class="form-check-label small" for="paramDefaultBool">{{ paramDefaultBool
                                            ? 'On' : 'Off' }}</label>
                                    </div>
                                </div>

                                <!-- number -->
                                <div class="col-12" *ngSwitchCase="'number'">
                                    <label class="small text-muted">Default Value
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="The starting numeric value when this rule is first added to a policy."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <input type="number" class="form-control form-control-sm" style="max-width:160px"
                                        [(ngModel)]="paramDefaultValue" [ngModelOptions]="{standalone: true}">
                                </div>

                                <!-- duration -->
                                <div class="col-12" *ngSwitchCase="'duration'">
                                    <label class="small text-muted">Default Value
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="The starting time value (24-hour HH:MM) when this rule is first added to a policy."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <input type="text" class="form-control form-control-sm" style="max-width:160px"
                                        placeholder="HH:MM" [(ngModel)]="paramDefaultValue"
                                        [ngModelOptions]="{standalone: true}">
                                </div>

                                <!-- repeatable-table -->
                                <div class="col-12" *ngSwitchCase="'repeatable-table'">
                                    <label class="small text-muted">Table Columns
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="Defines the columns of the table this rule renders. Rows themselves aren't set here — they get added later, whenever this rule is applied to a policy."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <div class="row g-2 align-items-end mb-2">
                                        <div class="col-md-3">
                                            <input type="text" class="form-control form-control-sm"
                                                [(ngModel)]="newColumnKey" [ngModelOptions]="{standalone: true}"
                                                placeholder="Column key">
                                        </div>
                                        <div class="col-md-3">
                                            <input type="text" class="form-control form-control-sm"
                                                [(ngModel)]="newColumnLabel" [ngModelOptions]="{standalone: true}"
                                                placeholder="Column label">
                                        </div>
                                        <div class="col-md-3">
                                            <select class="form-select form-select-sm" [(ngModel)]="newColumnType"
                                                [ngModelOptions]="{standalone: true}">
                                                <option *ngFor="let ct of columnTypeOptions" [value]="ct.value">{{
                                                    ct.label }}</option>
                                            </select>
                                        </div>
                                        <div class="col-md-3">
                                            <button type="button" class="btn btn-sm btn-outline-secondary w-100"
                                                (click)="addColumn()">Add Column</button>
                                        </div>
                                    </div>
                                    <div *ngIf="newColumnType === 'select'" class="mb-2">
                                        <div class="d-flex gap-2 mb-1">
                                            <input type="text" class="form-control form-control-sm"
                                                [(ngModel)]="newColumnOptionInput" [ngModelOptions]="{standalone: true}"
                                                placeholder="Add column option"
                                                (keydown.enter)="$event.preventDefault(); addColumnOption()">
                                            <button type="button" class="btn btn-sm btn-outline-secondary text-nowrap"
                                                (click)="addColumnOption()">Add</button>
                                        </div>
                                        <div class="d-flex flex-wrap gap-1">
                                            <span class="badge bg-light text-dark border"
                                                *ngFor="let opt of newColumnOptions">
                                                {{ opt }}
                                                <i class="fa fa-times ms-1" style="cursor:pointer"
                                                    (click)="removeColumnOption(opt)"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <table class="table table-sm table-bordered mb-0" *ngIf="paramColumns.length">
                                        <thead class="table-light">
                                            <tr>
                                                <th>Key</th>
                                                <th>Label</th>
                                                <th>Type</th>
                                                <th>Options</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let col of paramColumns; let ci = index">
                                                <td class="small font-monospace">{{ col.key }}</td>
                                                <td class="small">{{ col.label }}</td>
                                                <td class="small">{{ col.type }}</td>
                                                <td class="small">{{ col.options.join(', ') || '—' }}</td>
                                                <td class="text-center">
                                                    <i class="fa fa-trash text-danger" style="cursor:pointer"
                                                        (click)="removeColumn(ci)"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <span class="small text-muted" *ngIf="paramColumns.length === 0">No columns added
                                        yet — each row in the resulting table follows these columns.</span>
                                </div>
                            </ng-container>
                        </div>

                        <!-- Companion value (paired field) — moved right under the control itself,
                             since this is the #1 thing people building a rule need next. -->
                        <hr>
                        <div class="form-check form-switch mb-2">
                            <input class="form-check-input" type="checkbox" id="showPaired" [(ngModel)]="showPaired"
                                [ngModelOptions]="{standalone: true}">
                            <label class="form-check-label small fw-medium" for="showPaired">Also collect a value with
                                this
                                <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                    ngbTooltip="Turn this on if, alongside the control above, you also need to collect an extra value. For example: a Yes/No switch for 'Charge a late fine', with a Number field right next to it for 'How many minutes late'."
                                    triggers="hover click" container="body"></i>
                            </label>
                        </div>
                        <div *ngIf="showPaired" class="ps-1">
                            <p class="small text-muted mb-2" *ngIf="paramFieldType === 'boolean'">
                                Turn the Default Value switch above (or in the Final Preview at the bottom) On/Off to
                                see when the value below would show.
                            </p>
                            <!-- One table for both existing paired values AND the add-new-value inputs,
                                 so the input row's columns line up exactly under "What to ask for /
                                 Kind of value / Choices / Starting value" instead of a separate form
                                 below with its own (mismatched) column widths. -->
                            <table class="table table-sm table-bordered mb-1 align-middle">
                                <thead class="table-light">
                                    <tr>
                                        <th style="width:28%">What to ask for</th>
                                        <th style="width:18%">Kind of value</th>
                                        <th style="width:28%">Choices</th>
                                        <th style="width:18%">Starting value</th>
                                        <th style="width:8%"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let p of paramPaired; let pi = index">
                                        <td class="small">{{ p.label || p.key }}</td>
                                        <td class="small">{{ p.type }}</td>
                                        <td class="small">{{ p.options.join(', ') || '—' }}</td>
                                        <td class="small">{{ p.default }}</td>
                                        <td class="text-center">
                                            <i class="fa fa-trash text-danger" style="cursor:pointer"
                                                (click)="removePaired(pi)"></i>
                                        </td>
                                    </tr>

                                    <!-- Add-new-value row -->
                                    <tr>
                                        <td>
                                            <input type="text" class="form-control form-control-sm"
                                                [(ngModel)]="newPairedLabel" [ngModelOptions]="{standalone: true}"
                                                placeholder="e.g. Present Days in Week"
                                                ngbTooltip="Plain-language label shown next to this extra value."
                                                triggers="hover click" container="body">
                                        </td>
                                        <td>
                                            <select class="form-select form-select-sm" [(ngModel)]="newPairedType"
                                                [ngModelOptions]="{standalone: true}">
                                                <option *ngFor="let pt of pairedTypeOptions" [value]="pt.value">{{
                                                    pt.label }}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <ng-container *ngIf="newPairedType === 'select'; else noPairedChoices">
                                                <div class="d-flex gap-1 mb-1">
                                                    <input type="text" class="form-control form-control-sm"
                                                        [(ngModel)]="newPairedOptionInput"
                                                        [ngModelOptions]="{standalone: true}" placeholder="Add a choice"
                                                        (keydown.enter)="$event.preventDefault(); addPairedOption()">
                                                    <button type="button"
                                                        class="btn btn-sm btn-outline-secondary text-nowrap"
                                                        (click)="addPairedOption()">Add</button>
                                                </div>
                                                <div class="d-flex flex-wrap gap-1">
                                                    <span class="badge bg-light text-dark border"
                                                        *ngFor="let opt of newPairedOptions">
                                                        {{ opt }}
                                                        <i class="fa fa-times ms-1" style="cursor:pointer"
                                                            (click)="removePairedOption(opt)"></i>
                                                    </span>
                                                </div>
                                            </ng-container>
                                            <ng-template #noPairedChoices>
                                                <span class="text-muted small">—</span>
                                            </ng-template>
                                        </td>
                                        <td>
                                            <div class="form-check form-switch"
                                                *ngIf="newPairedType === 'boolean'; else pairedDefaultInput">
                                                <input class="form-check-input" type="checkbox"
                                                    [(ngModel)]="newPairedDefault"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <ng-template #pairedDefaultInput>
                                                <input *ngIf="newPairedType !== 'select'" type="text"
                                                    class="form-control form-control-sm"
                                                    [(ngModel)]="newPairedDefault"
                                                    [ngModelOptions]="{standalone: true}"
                                                    [placeholder]="newPairedType === 'duration' ? 'HH:MM' : '0'">
                                                <select *ngIf="newPairedType === 'select'"
                                                    class="form-select form-select-sm" [(ngModel)]="newPairedDefault"
                                                    [ngModelOptions]="{standalone: true}">
                                                    <option *ngFor="let opt of newPairedOptions" [value]="opt">{{ opt
                                                        }}</option>
                                                </select>
                                            </ng-template>
                                        </td>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-sm btn-primary" title="Add this value"
                                                (click)="newPairedKey = newPairedKey || toCamelKey(newPairedLabel); addPaired()">
                                                <i class="bi bi-plus-lg"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="small text-muted mb-2">
                                (A technical key is generated automatically from what you type above.)
                            </div>
                        </div>

                        <!-- Only-show-when condition (advanced, collapsible) -->
                        <hr>
                        <div class="form-check form-switch mb-2">
                            <input class="form-check-input" type="checkbox" id="showVisibility"
                                [(ngModel)]="showVisibility" [ngModelOptions]="{standalone: true}">
                            <label class="form-check-label small fw-medium" for="showVisibility">Advanced: only show
                                this rule when another rule is set a certain way
                                <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                    ngbTooltip="Hides this whole rule unless another rule in the same category currently equals a given value — e.g. only show 'Present Days in Week' when 'Holiday Rule' equals 'Weekly Off'. Most rules don't need this."
                                    triggers="hover click" container="body"></i>
                            </label>
                        </div>
                        <div *ngIf="showVisibility" class="ps-1 mb-1">
                            <div class="row g-2 align-items-end mb-2">
                                <div class="col-md-5">
                                    <label class="small text-muted">The other rule's Field Key
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="The Field Key of another rule already defined in this category — visible in the Field Key / Type column of the rules list."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <input type="text" class="form-control form-control-sm"
                                        [(ngModel)]="newVisibleWhenField" [ngModelOptions]="{standalone: true}"
                                        placeholder="e.g. holidayRule">
                                </div>
                                <div class="col-md-5">
                                    <label class="small text-muted">Must equal
                                        <i class="bi bi-info-circle text-muted ms-1" style="cursor:pointer"
                                            ngbTooltip="The value that other rule must currently have for this one to appear. For a Yes/No switch, type true or false."
                                            triggers="hover click" container="body"></i>
                                    </label>
                                    <input type="text" class="form-control form-control-sm"
                                        [(ngModel)]="newVisibleWhenEquals" [ngModelOptions]="{standalone: true}"
                                        placeholder="e.g. Weekly Off, or true">
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-sm btn-outline-secondary w-100"
                                        (click)="addVisibleWhen()">Add</button>
                                </div>
                            </div>
                            <div class="d-flex flex-wrap gap-1">
                                <span class="badge bg-light text-dark border"
                                    *ngFor="let cond of paramVisibleWhen; let vi = index">
                                    {{ cond.field }} = "{{ cond.equals }}"
                                    <i class="fa fa-times ms-1" style="cursor:pointer"
                                        (click)="removeVisibleWhen(vi)"></i>
                                </span>
                                <span class="small text-muted" *ngIf="paramVisibleWhen.length === 0">No conditions added
                                    — rule is always shown.</span>
                            </div>
                        </div>

                        <!-- Final preview: sits last, after every section above has been filled in, so it
                             reflects the complete rule - primary control, paired value, and visibility
                             condition together - exactly as a tenant will actually see it. Inputs here are
                             live-bound to the same properties as the form above, so playing with the preview
                             edits the real values too - it's a second way to set them, not just a picture. -->
                        <hr>
                        <div class="final-preview-panel">
                            <div class="final-preview-title mb-2">
                                <i class="bi bi-eye-fill me-1"></i>Final Preview — exactly what a tenant sees when they add this
                                rule to a policy:
                            </div>
                            <div class="d-flex align-items-center flex-wrap gap-3">
                                <!-- Control Label is a caption meant to replace the Rule Name right next to the
                                     control (see its tooltip) - showing both here just repeats the same idea twice. -->
                                <span class="fw-medium small" *ngIf="!paramControlLabel">{{ ruleForm.get('ruleName')?.value
                                    || '(Rule Name)' }}</span>
                                <span class="fw-medium small" *ngIf="paramControlLabel">{{ paramControlLabel }}</span>

                                <div class="form-check form-switch mb-0" *ngIf="paramFieldType === 'boolean'">
                                    <input class="form-check-input" type="checkbox" [(ngModel)]="paramDefaultBool"
                                        [ngModelOptions]="{standalone: true}">
                                </div>

                                <select *ngIf="paramFieldType === 'select'" class="form-select form-select-sm"
                                    style="width:auto" [(ngModel)]="paramDefaultValue"
                                    [ngModelOptions]="{standalone: true}">
                                    <option *ngFor="let opt of paramOptions" [value]="opt">{{ opt }}</option>
                                </select>
                                <span *ngIf="paramFieldType === 'select' && paramOptions.length === 0"
                                    class="small text-muted fst-italic">(add options above to preview this
                                    dropdown)</span>

                                <div class="d-flex flex-wrap gap-2" *ngIf="paramFieldType === 'multiselect'">
                                    <span class="badge rounded-pill" style="cursor:pointer"
                                        *ngFor="let opt of paramOptions"
                                        [class.bg-primary]="paramDefaultMultiselect.includes(opt)"
                                        [class.text-white]="paramDefaultMultiselect.includes(opt)"
                                        [class.bg-light]="!paramDefaultMultiselect.includes(opt)"
                                        [class.text-dark]="!paramDefaultMultiselect.includes(opt)"
                                        [class.border]="!paramDefaultMultiselect.includes(opt)"
                                        (click)="toggleMultiselectDefault(opt)">{{ opt }}</span>
                                    <span *ngIf="paramOptions.length === 0" class="small text-muted fst-italic">(add
                                        options above to preview this list)</span>
                                </div>

                                <input *ngIf="paramFieldType === 'number'" type="number"
                                    class="form-control form-control-sm text-end" style="max-width:100px"
                                    [(ngModel)]="paramDefaultValue" [ngModelOptions]="{standalone: true}">

                                <span *ngIf="paramFieldType === 'duration'" class="small">{{ paramDefaultValue ||
                                    '00:00' }}</span>

                                <span *ngIf="paramFieldType === 'repeatable-table'"
                                    class="small text-muted fst-italic">
                                    A table with columns: {{ paramColumns.length ? paramColumnsPreviewText() : '(add
                                    columns above to preview them)' }}
                                </span>

                                <ng-container *ngIf="showPaired && (paramFieldType !== 'boolean' || paramDefaultBool)">
                                    <span *ngFor="let p of paramPaired" class="text-muted small">
                                        {{ p.label || p.key }}: <strong>{{ p.default }}</strong>
                                    </span>
                                </ng-container>
                                <span *ngIf="showPaired && paramFieldType === 'boolean' && !paramDefaultBool"
                                    class="small text-muted fst-italic">
                                    (turned Off right now — the paired value below stays hidden until it's switched
                                    On)
                                </span>
                            </div>

                            <!-- Plain-language recap of the Advanced visibility condition, since the preview
                                 above can't visually demonstrate "this row only shows sometimes". -->
                            <div class="small mt-2 pt-2 border-top border-primary-subtle" *ngIf="showVisibility">
                                <i class="bi bi-signpost-split text-muted me-1"></i>
                                <span *ngIf="paramVisibleWhen.length" class="text-muted">
                                    Only appears on a policy when
                                    <ng-container *ngFor="let cond of paramVisibleWhen; let last = last">
                                        <strong>{{ cond.field }}</strong> = "<strong>{{ cond.equals }}</strong>"<span *ngIf="!last"> and </span>
                                    </ng-container>
                                </span>
                                <span *ngIf="!paramVisibleWhen.length" class="text-muted fst-italic">
                                    No conditions added yet above — right now this rule would always be shown.
                                </span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="modal-footer text-end">
        <button type="submit" class="btn btn-primary btn-sm ms-2" (click)="submitGlobalPolicyRule()"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status"
                aria-hidden="true"></span>
            <span>{{ isLoading ? 'Saving...' : 'Save' }}</span>
        </button>
        <button type="reset" class="btn btn-outline-secondary btn-sm" (click)="resetRuleForm()">Reset</button>
    </div>
</ng-template>

<!-- Shared worked-examples content — reused by both the inline expand-panel above
     and the standalone "How to configure rules" modal below, so there's one source of truth. -->
<ng-template #howToContent>

    <div class="rule-guide">

        <!-- Overall workflow - condensed to a single inline line since each tab below now
             covers "select the control type + configure it" in detail on its own. -->
        <p class="guide-description mb-3">
            <i class="bi bi-list-ol me-1"></i>
            <strong>Rule Category</strong> → <strong>Rule Name</strong> → pick a control type below → configure it →
            Save.
        </p>

        <!-- Control-type tabs: pick the type first (same options as the real "What kind of
             control is this?" dropdown), then see only that type's steps + example - instead
             of scrolling past a lookup table, a generic steps list, and every type's
             instructions stacked in one long accordion. -->
        <div class="guide-tabs d-flex flex-wrap gap-2 mb-3">
            <button *ngFor="let tab of howToGuideTabs" type="button" class="guide-badge guide-tab-btn"
                [ngClass]="tab.badgeClass" [class.active]="howToGuideTab === tab.value"
                (click)="howToGuideTab = tab.value">
                {{ tab.label }}
            </button>
        </div>

        <ng-container *ngFor="let tab of howToGuideTabs">
            <div class="guide-section mb-0" *ngIf="howToGuideTab === tab.value">

                <p class="guide-description">
                    <strong>When to use:</strong> {{ tab.whenToUse }}
                </p>

                <ol class="guide-list">
                    <li *ngFor="let step of tab.steps" [innerHTML]="step"></li>
                </ol>

                <div class="example-box">
                    Example: <span [innerHTML]="tab.example"></span>
                </div>

            </div>
        </ng-container>



    </div>


</ng-template>
<!-- Standalone "How to configure rules" modal — opened from the toolbar, readable anytime
     without needing to open the Create/Update Rule form first. -->
<ng-template #HowToRuleGuideModal>
    <div class="modal-header bg-warning text-white">
        <h5 class="modal-title">How to configure a rule</h5>
        <button type="button" class="btn-close btn-close-white" (click)="howToGuideModalRef.close()"></button>
    </div>
    <div class="modal-body">
        <ng-container *ngTemplateOutlet="howToContent"></ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary btn-sm"
            (click)="howToGuideModalRef.close()">Close</button>
    </div>
</ng-template>